"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
    return f;
  })(e, t);
}
var _default = function _default(_ref) {
  var time = _ref.time;
  var currentTime = (0, _react.useRef)(time);
  var prevTime = (0, _react.useRef)(null);
  var isNewTimeFirstTick = (0, _react.useRef)(false);
  if (currentTime.current !== time) {
    isNewTimeFirstTick.current = true;
    prevTime.current = currentTime.current;
    currentTime.current = time;
  } else {
    isNewTimeFirstTick.current = false;
  }
  var isTimeUp = isNewTimeFirstTick.current;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "time-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    key: time,
    className: "time ".concat(isTimeUp ? 'up' : '')
  }, time), prevTime.current !== null && /*#__PURE__*/_react.default.createElement("div", {
    key: prevTime.current,
    className: "time ".concat(!isTimeUp ? 'down' : '')
  }, prevTime.current));
};
exports.default = _default;